import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const Product = ({
  images,
  stanzas,
}) => (
  <div className={styles.wrapper}>
    {images && images.map((image, i) => (
      <img 
        className={styles.image}
        alt={image.title}
        key={`image${i}`} 
        src={image.asset.file.url} 
      />
    ))}
    <div className={styles.content}>
      {stanzas && stanzas.map(({ alignment, text }, i) => (
        <div
          dangerouslySetInnerHTML={{ __html: text.childMarkdownRemark.html}}
          style={{ textAlign: alignment || 'left' }}
          key={`parent${i}`}
        />
      ))}
    </div>
  </div>
);

Product.propTypes = {
  images: PropTypes.array,
  stanzas: PropTypes.array,
};

Product.defaultProps = {
  images: [],
  stanzas: [],
};

export default Product;



// WEBPACK FOOTER //
// ./src/components/Product/index.jsx